/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SentTime/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Data/format.js'
import Body from 'DesignSystem/Body/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function SentTime({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/EventsTimeline/Content/Event/Types/Internal/Content/Mine/SentTime"
  
}) {
let internalCreatedAtValueData = fromData.useDataFormat({ viewPath,
context: 'internal',
path: 'created_at',
format: fromFormat.dateISOToTime,
})
  return (<React.Fragment
>
<Body
  viewPath={`${viewPath}/Body`}
 fontSize={12}
 marginLeft={8}
 marginRight={8}
 marginTop={2}
 color="rgba(0,0,0,0.7)"
 data="internal.created_at"
 format="/Data/format.js dateISOToTime"
 text={internalCreatedAtValueData}
/>
{children}
</React.Fragment>)
}